import i18n from 'shared/lib/i18n';

import { GET_STATISTICS_SUCCESS } from '../actionConstants';

import {
  getDoorOpeningsPhotoUrl,
  getDoorOpeningsText,
  getLiveCameraViewUrl,
  getMessagesSentUrl,
  getMostReceivedText,
  getPersonUrl,
  getPhotoUrl,
  getSRStatisticsUrl,
} from '../components/Statistics/utils';
import { formatDate } from '../utils';

const filterMostValues = (v) => {
  // TODO check if it'll work with Fr
  const isMostValue = v.title.includes(i18n.t('statistics.most'));
  const hasValue = v.value > 0;
  if (isMostValue && !hasValue) return false;
  return true;
};

const getWeeklyTemplateData = (data) => {
  if (!data) return null;
  const {
    dateRange = [],
    propertyStats,
    staff: allStaff,
    residents: allResidents,
    intercomCalls: { intercomCalls },
    serviceRequestEvents,
    averageResponseTime,
    requestsOpenMoreThan_7_days,
    mostActiveStaffMember,
    doorOpenings: { all, brokers, residents, staff, visitors },
    property,
    deliveries,
    mostDeliveriesReceived,
    liveCameraViews,
    paymentsAccessed,
    messagesSent,
  } = data;
  const [startDate, endDate] = dateRange;
  return {
    startDate: formatDate(startDate, true, 'M/D'),
    endDate: formatDate(endDate, true, 'M/D'),
    buildingsIncluded: propertyStats.buildingsIncludedStr,
    properties: [
      {
        // title is taken from the current property
        // title: null,
        // subtitle is not used for now
        // subtitle: [
        //   {
        //     value: registeredResidents,
        //     measure: '%',
        //     text: 'Resident Registered on Carson',
        //   },
        //   {
        //     value: residentsLoggedIn,
        //     measure: '%',
        //     text: 'of resident logged in',
        //   },
        //   {
        //     value: staffLoggedIn,
        //     measure: '',
        //     text: 'of staff logged in',
        //   },
        //   {
        //     value: intercomCalls,
        //     measure: '',
        //     text: 'intercom calls',
        //     show: hasCallableIntercom,
        //   },
        // ],
        categories: [
          {
            header: {
              title: i18n.t('statistics.buildings-or-units'),
              subtitle: null,
              value: `${propertyStats.buildingCount}/${propertyStats.unitCount}`,
              measure: '',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('title.residents'),
              subtitle: null,
              value: allResidents.total,
              measure: '',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.residents-registered'),
              subtitle: null,
              value: allResidents.registered,
              measure: '%',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.residents-logged-in'),
              subtitle: null,
              value: allResidents.loggedIn,
              measure: '%',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('title.staff'),
              subtitle: null,
              value: allStaff.total,
              measure: '',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.staff-registered'),
              subtitle: null,
              value: allStaff.registered,
              measure: '%',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.staff-logged-in'),
              subtitle: null,
              value: allStaff.loggedIn,
              measure: '%',
              percent: null,
              isPositive: null,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.intercom-calls'),
              subtitle: null,
              value: intercomCalls,
              measure: '',
              percent: intercomCalls?.pastDateRangeDynamics,
              isPositive: intercomCalls?.isPositive,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.live-camera-views'),
              subtitle: null,
              value: liveCameraViews?.total,
              measure: null,
              percent: liveCameraViews?.pastDateRangeDynamics,
              isPositive: liveCameraViews?.isPositive,
              link: getLiveCameraViewUrl(startDate, endDate),
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.payments-accessed'),
              subtitle: null,
              value: paymentsAccessed?.total,
              measure: null,
              percent: paymentsAccessed?.pastDateRangeDynamics,
              isPositive: paymentsAccessed?.isPositive,
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.messages-sent'),
              subtitle: null,
              value: messagesSent?.total,
              measure: null,
              percent: messagesSent?.pastDateRangeDynamics,
              isPositive: messagesSent?.isPositive,
              link: getMessagesSentUrl(startDate, endDate),
            },
            details: [],
          },
          {
            header: {
              title: i18n.t('statistics.service-request-events'),
              subtitle: i18n.t(
                'statistics.submitted-closed-status-changes-comments',
              ),
              value: serviceRequestEvents?.total,
              measure: null,
              percent: serviceRequestEvents?.pastDateRangeDynamics,
              isPositive: serviceRequestEvents?.isPositive,
            },
            details: [
              {
                title: i18n.t('statistics.average-time-to-respond'),
                subtitle: { photoUrl: null, text: null },
                value: [
                  averageResponseTime?.total?.days,
                  averageResponseTime?.total?.hours,
                ],
                measure: ['d', 'hrs'],
                percent: averageResponseTime?.pastDateRangeDynamics,
                isPositive: averageResponseTime?.isPositive,
              },
              {
                title: i18n.t('statistics.requests-open-for-more-than-7-days'),
                subtitle: { photoUrl: null, text: null },
                value: requestsOpenMoreThan_7_days?.total,
                measure: null,
                percent: requestsOpenMoreThan_7_days?.pastDateRangeDynamics,
                isPositive: requestsOpenMoreThan_7_days?.isPositive,
                link: getSRStatisticsUrl(property),
              },
              {
                title: i18n.t('statistics.most-active-staff-member'),
                subtitle: {
                  photoUrl:
                    getMostReceivedText(mostActiveStaffMember) &&
                    getPhotoUrl(mostActiveStaffMember),
                  text:
                    getMostReceivedText(mostActiveStaffMember) ??
                    i18n.t('statistics.no-staff-activity'),
                  link: getPersonUrl(mostActiveStaffMember), // for PMC?
                },
                value: mostActiveStaffMember?.total,
                measure: i18n.t('statistics.service-request-events'),
                percent: null,
              },
            ].filter(filterMostValues),
          },
          {
            header: {
              title: i18n.t('statistics.door-openings'),
              subtitle: null,
              value: all?.total,
              measure: null,
              percent: all?.pastDateRangeDynamics,
              isPositive: all?.isPositive,
            },
            details: [
              {
                title: i18n.t('statistics.resident-door-openings'),
                subtitle: { photoUrl: null, text: null },
                value: residents?.total,
                measure: '',
                percent: residents?.pastDateRangeDynamics,
                isPositive: residents?.isPositive,
              },
              {
                title: i18n.t('statistics.most-door-openings'),
                subtitle: {
                  photoUrl: getDoorOpeningsPhotoUrl(residents),
                  text: getDoorOpeningsText(residents, true, true),
                  link: getPersonUrl(residents),
                },
                value: residents?.mostDoorOpenings?.total,
                measure: null,
                percent: null,
                isSubtype: true,
              },

              {
                title: i18n.t('statistics.staff-door-openings'),
                subtitle: { photoUrl: null, text: null },
                value: staff?.total,
                measure: '',
                percent: staff?.pastDateRangeDynamics,
                isPositive: staff?.isPositive,
              },
              {
                title: i18n.t('statistics.most-door-openings'),
                subtitle: {
                  photoUrl: getDoorOpeningsPhotoUrl(staff),
                  text: getDoorOpeningsText(staff, true),
                  link: getPersonUrl(staff),
                },
                value: staff?.mostDoorOpenings?.total,
                measure: null,
                percent: null,
                isSubtype: true,
              },

              {
                title: i18n.t('statistics.visitor-vendor-door-openings'),
                subtitle: { photoUrl: null, text: null },
                value: visitors?.total,
                measure: '',
                percent: visitors?.pastDateRangeDynamics,
                isPositive: visitors?.isPositive,
              },
              {
                title: i18n.t('statistics.text-message-entries'),
                subtitle: { photoUrl: null, text: null },
                value: visitors?.openingsByMethod?.textCode,
                measure: '',
                percent: null,
                isPositive: null,
                isSubtype: true,
              },
              {
                title: i18n.t('statistics.app-entries-by-visitors'),
                subtitle: { photoUrl: null, text: null },
                value: visitors?.openingsByMethod?.carsonApp,
                measure: '',
                percent: null,
                isPositive: null,
                isSubtype: true,
              },
              {
                title: i18n.t('statistics.most-door-openings'),
                subtitle: {
                  photoUrl: getDoorOpeningsPhotoUrl(visitors),
                  text: getDoorOpeningsText(visitors),
                  link: getPersonUrl(visitors),
                },
                value: visitors?.mostDoorOpenings?.total,
                measure: null,
                percent: null,
                isSubtype: true,
              },

              {
                title: i18n.t('statistics.broker-door-openings'),
                subtitle: { photoUrl: null, text: null },
                value: brokers?.total,
                measure: '',
                percent: brokers?.pastDateRangeDynamics,
                isPositive: brokers?.isPositive,
              },
              {
                title: i18n.t('statistics.most-door-openings'),
                subtitle: {
                  photoUrl: getDoorOpeningsPhotoUrl(brokers),
                  text: getDoorOpeningsText(brokers),
                  link: getPersonUrl(brokers),
                },
                value: brokers?.mostDoorOpenings?.total,
                measure: null,
                percent: null,
                isSubtype: true,
              },
            ].filter(filterMostValues),
          },
          {
            header: {
              title: i18n.t('statistics.deliveries-handled-by-carson'),
              subtitle: null,
              value: deliveries?.total,
              measure: null,
              percent: deliveries?.pastDateRangeDynamics,
              isPositive: deliveries?.isPositive,
            },
            details: [
              {
                title: i18n.t('statistics.most-deliveries-received'),
                subtitle: {
                  photoUrl: getPhotoUrl(mostDeliveriesReceived),
                  text: getMostReceivedText(mostDeliveriesReceived, true, true),
                  link: getPersonUrl(mostDeliveriesReceived),
                },
                value: mostDeliveriesReceived?.total,
                measure: i18n.t('title.deliveries'),
                percent: null,
              },
            ].filter(filterMostValues),
          },
        ],
      },
    ],
  };
};

const defaultState = null;

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_STATISTICS_SUCCESS: {
      const data = action?.res?.data;
      const reportData = getWeeklyTemplateData(data);
      return reportData;
    }
    case '@@router/LOCATION_CHANGE':
      return null;
    default:
      return state;
  }
};
